import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import MeetingRoomTwoTone from '@material-ui/icons/MeetingRoomTwoTone';
import RoomTwoTone from '@material-ui/icons/RoomTwoTone';
import React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { useGameContext } from './hooks';
import { Screen } from './Screen';

export const Lobby = () => {
  const { roomId, playerId } = useGameContext();
  return (
    <Screen title="Lobby" hideBreadcrumbs>
      <Card>
        <CardMedia
          component="img"
          alt="Nua oans"
          image="Nua oans.jpg"
          title="Nua oans"
        />
        <CardActions>
          {roomId && playerId &&
            <Button variant="contained" component={RouterLink} to="/room" startIcon={<MeetingRoomTwoTone/>}>
              Betrete letzten Raum
            </Button>
          }
          <Button variant="contained" component={RouterLink} to="/room/create" startIcon={<RoomTwoTone/>}>
            Erzeuge einen Raum
          </Button>
          <Button variant="contained" component={RouterLink} to="/room/enter" startIcon={<MeetingRoomTwoTone/>}>
            Betrete einen Raum
          </Button>
        </CardActions>
      </Card>
    </Screen>
  );
};

export default Lobby;
